var React = require('react');

function RetailClothingInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"className":"background","width":"48","height":"48","fill":"none","key":0}),React.createElement("path",{"d":"M12.2 34.6H37.8","stroke":"#1769FF","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M37.8 41V34.6C37.8 34.6 41 29.4608 41 25.0992C41 18.1056 37.8 9 37.8 9H33C34.1504 12.1744 36.4208 19.08 33 21.8C30.92 23.4496 26.6256 23.4 25 23.4C23.3744 23.4 19.08 23.4496 17 21.8C13.5792 19.08 15.8496 12.1744 17 9H12.2C12.2 9 9 18.1056 9 25.0992C9 29.4608 12.2 34.6 12.2 34.6V41H37.8Z","stroke":"#090D12","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

RetailClothingInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = RetailClothingInline;

RetailClothingInline.default = RetailClothingInline;
